import React, { useMemo } from 'react';
import styled from 'styled-components';
import { FeatureAppLoader } from '@feature-hub/react';

import { getVideoPlayerConfig } from '../utils/getVideoPlayerConfig';
import type { AssetTypeVideo, FeatureAppMeta } from '../../types';
import { SYS_BORDER_RADIUS_MD } from '@oneaudi/unified-web-common';

const VIDEO_PLAYER_FA_NAME = 'fa-video-player';
const VIDEO_PLAYER_FA_VERSION = 'v5.5.4';
const VIDEO_PLAYER_FA_ENV = 'prod';
const VIDEO_PLAYER_FA_BASE_URL = `https://${VIDEO_PLAYER_FA_NAME}.cdn.${VIDEO_PLAYER_FA_ENV}.collab.apps.one.audi/${VIDEO_PLAYER_FA_VERSION}`;

export interface VideoWrapperProps {
  preserveVideoWidth?: boolean;
}

const VideoWrapper = styled.div<VideoWrapperProps>`
  width: 100%;
  ${!process.env.IS_LEGACY ? `border-radius: ${SYS_BORDER_RADIUS_MD}; overflow: hidden;` : ''}

  ${(props) => {
    return `
    height: ${props.preserveVideoWidth ? 'auto' : '100%'};
    min-height:  ${props.preserveVideoWidth ? 'auto' : '100%'};
    `;
  }}

  img {
    display: inline !important;
  }
  video {
    display: block; /* removes the gap at the bottom of the video */
    object-fit: ${(props) => (props.preserveVideoWidth ? 'contain' : 'cover')};
  }
`;

interface VideoProps {
  asset: AssetTypeVideo;
  meta: FeatureAppMeta;
}

export const Video = ({ asset, meta }: VideoProps) => {
  const videoPlayerConfig = useMemo(() => getVideoPlayerConfig(asset), [asset]);
  const serverSrcFile = process.env.IS_LEGACY ? '/fh/app.node.js' : '/fh/app-alpha.node.js';
  const clientSrcFile = process.env.IS_LEGACY ? '/fh/app.js' : '/fh/app-alpha.js';
  return (
    <VideoWrapper preserveVideoWidth={asset.preserveVideoWidth}>
      <FeatureAppLoader
        featureAppId={`${meta.id}_${VIDEO_PLAYER_FA_NAME}`}
        featureAppName={VIDEO_PLAYER_FA_NAME}
        config={videoPlayerConfig}
        serverSrc={VIDEO_PLAYER_FA_BASE_URL + serverSrcFile}
        src={VIDEO_PLAYER_FA_BASE_URL + clientSrcFile}
      />
    </VideoWrapper>
  );
};
